/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TypeInputs */

const en__field_type = /** @type {(inputs: _Field_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token type`)
};

/** @type {(inputs: _Field_TypeInputs) => LocalizedString} */
const de__field_type = en__field_type;

/**
* | output |
* | --- |
* | "Token type" |
*
* @param {_Field_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_type = /** @type {((inputs?: _Field_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_type(inputs)
	return de__field_type(inputs)
});